import * as types from "../types/nft"
import {
    FILTER_NFT_BY_TAGS,
    FILTER_NFT_BY_TAGS_FAILURE,
    FILTER_NFT_BY_TAGS_SUCCESS,
    FILTER_SEARCH_NFT_COLLECTION
} from "../types/nft";

let initialState = {
    nfts:[],
    loading:false,
    searchedNFTs:[],
    searchedName:"",
    isSearched:false,
    error:""
}


export const nftReducer = (state=initialState,action)=>{
    let {type,payload}=action;
    switch (type){
        case types.FETCH_NFT_COLLECTION:
            return{
                ...state,
                nfts: [],
                loading:true,
            }
        case types.FETCH_NFT_COLLECTION_SUCCESS:
            return {
                ...state,
                nfts:payload.nfts,
                loading:false,
            }
        case types.FETCH_NFT_COLLECTION_FAILURE:
            return {
                ...state,
                nfts:[],
                loading:false,
                error:payload
            }
        case types.SEARCH_NFT_COLLECTION:
            return{
                ...state,
                nfts: [],
                loading:true,
                searchedName:payload,
            }
        case types.SEARCH_NFT_COLLECTION_SUCCESS:
            return {
                ...state,
                searchedNFTs:payload.searchedNFTs,
                nfts:payload.searchedNFTs,
                loading:false,
            }
        case types.SEARCH_NFT_COLLECTION_FAILURE:
            return {
                ...state,
                nfts:[],
                loading:false,
                error:payload
            }
        case types.FILTER_NFT_BY_TAGS:
            return{
                ...state,
                nfts: [],
                loading:true,
            }
        case types.FILTER_NFT_BY_TAGS_SUCCESS:
            return {
                ...state,
                searchedNFTs:payload.searchedNFTs,
                nfts:payload.searchedNFTs,
                loading:false,
            }
        case types.FILTER_NFT_BY_TAGS_FAILURE:
            return {
                ...state,
                nfts:[],
                loading:false,
                error:payload
            }
        case types.FILTER_SEARCH_NFT_COLLECTION:
            return{
                ...state,
                nfts: [],
                loading:true,
                searchedName:payload,
            }
        case types.FILTER_SEARCH_NFT_COLLECTION_SUCCESS:
            return {
                ...state,
                searchedNFTs:payload.searchedNFTs,
                nfts:payload.searchedNFTs,
                loading:false,
            }
        case types.FILTER_SEARCH_NFT_COLLECTION_FAILURE:
            return {
                ...state,
                nfts:[],
                loading:false,
                error:payload
            }

        default :return state;
    }
}